import React from "react";
import { Phone, Mail, Facebook, Instagram } from "lucide-react";
import { contactInfo, partners } from "../data/mock";

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      {/* Main Footer */}
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <img
              src="https://customer-assets.emergentagent.com/job_smx-medical-redesign/artifacts/h8y6r4xk_Untitled%20%28300%20x%20150%20px%29.png"
              alt="SMX Medical Logo"
              className="h-20 w-auto object-contain mb-4 bg-white rounded p-2"
            />
            <p className="text-sm leading-relaxed">
              Your trusted partner in delivering exceptional medical and first aid coverage for events across Surrey, Sussex, and beyond.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <a href="#home" className="hover:text-[#0056c5] transition-colors">
                  Home
                </a>
              </li>
              <li>
                <a href="#services" className="hover:text-[#0056c5] transition-colors">
                  Services
                </a>
              </li>
              <li>
                <a href="#training" className="hover:text-[#0056c5] transition-colors">
                  Training Courses
                </a>
              </li>
              <li>
                <a href="#about" className="hover:text-[#0056c5] transition-colors">
                  About Us
                </a>
              </li>
              <li>
                <a href="#contact" className="hover:text-[#0056c5] transition-colors">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li>
                <a
                  href={`tel:${contactInfo.phone.replace(/\s/g, "")}`}
                  className="flex items-center gap-2 hover:text-[#0056c5] transition-colors"
                >
                  <Phone className="h-4 w-4" />
                  {contactInfo.phone}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${contactInfo.email}`}
                  className="flex items-center gap-2 hover:text-[#0056c5] transition-colors"
                >
                  <Mail className="h-4 w-4" />
                  {contactInfo.email}
                </a>
              </li>
            </ul>

            {/* Social Links */}
            <div className="flex gap-4 mt-6">
              <a
                href={contactInfo.social.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-gray-800 p-2 rounded-full hover:bg-[#0056c5] transition-colors"
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a
                href={contactInfo.social.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-gray-800 p-2 rounded-full hover:bg-[#0056c5] transition-colors"
              >
                <Instagram className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Partners */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Our Partners</h3>
            <div className="space-y-4">
              {partners.map((partner, index) => (
                <div key={index}>
                  <a
                    href={partner.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block bg-white rounded p-2 hover:shadow-lg transition-shadow"
                  >
                    <img
                      src={partner.logo}
                      alt={partner.name}
                      className="h-12 w-auto object-contain"
                    />
                  </a>
                  {partner.note && (
                    <p className="text-xs mt-1">{partner.note}</p>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm">
            <p>© 2025 SMX Medical Ltd. All rights reserved.</p>
            <div className="flex gap-6">
              <a href="#privacy" className="hover:text-[#0056c5] transition-colors">
                Privacy Policy
              </a>
              <a href="#terms" className="hover:text-[#0056c5] transition-colors">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
